import React from "react";

// Data for Life Updates
const lifeUpdates = [
  {
    id: 1,
    category: "Event",
    title: "Tech Conference 2023",
    date: "Sep 12, 2023",
    image:
      "https://images.unsplash.com/photo-1544531586-fde5298cdd40?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 2,
    category: "Culture",
    title: "Team Pizza Night",
    date: "Aug 20, 2023",
    image:
      "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 3,
    category: "Office",
    title: "New Workspace Setup",
    date: "Aug 01, 2023",
    image:
      "https://images.unsplash.com/photo-1497215728101-856f4ea42174?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 4,
    category: "Awards",
    title: "Best UI Design Award",
    date: "Jul 15, 2023",
    image:
      "https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 5,
    category: "Team",
    title: "New Joiners",
    date: "Jul 10, 2023",
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 6,
    category: "Workshop",
    title: "React Workshop",
    date: "Jun 05, 2023",
    image:
      "https://images.unsplash.com/photo-1515187029135-18ee286d815b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  },
];

// --- Reusable Photo Card Component ---
const LifeCard = ({ item }) => (
  <div className="group relative aspect-[4/5] rounded-2xl overflow-hidden cursor-pointer">
    {/* Background Image */}
    <img
      src={item.image}
      alt={item.title}
      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
    />

    {/* Gradient Overlay (Bottom to Top) */}
    <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-300"></div>

    {/* Content on Image */}
    <div className="absolute bottom-0 left-0 w-full p-6 flex flex-col items-start">
      {/* Category Tag */}
      <span className="mb-2 px-3 py-1 bg-blue-500/90 text-white text-[10px] font-bold uppercase tracking-wider rounded-md backdrop-blur-sm">
        {item.category}
      </span>

      {/* Title */}
      <h3 className="text-xl font-bold text-white mb-1 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
        {item.title}
      </h3>

      {/* Date */}
      <span className="text-slate-300 text-sm font-medium transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300 delay-75">
        {item.date}
      </span>
    </div>
  </div>
);

const LifeAtCompanySection = () => {
  return (
    <section className="py-24 bg-slate-900 text-white">
      <div className="container mx-auto px-6 max-w-screen-xl">
        {/* --- Section Header --- */}
        <div className="text-center mb-16">
          <span className="text-blue-400 font-bold tracking-wider uppercase text-xs">
            Beyond the Code
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mt-2 mb-4">
            Life at Company
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            We work hard, but we celebrate harder. Here is a glimpse into our
            culture and fun moments.
          </p>
        </div>

        {/* --- Photo Grid Layout --- */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {lifeUpdates.map((item) => (
            <LifeCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifeAtCompanySection;
